import React from 'react';
import {h, Component} from 'preact'
import ActionButton from "../ActionButton";

export default class WindowHeader extends Component {
    render() {
        const {
            title,
            soundNotifications,
            toggleNotifications,
            toggleFullScreen,
            embedButton,
            logo,
            toggleOpen,
            closeButton,
        } = this.props;

        return (
            <div className="window-header">
                <div className="name">
                    <img src={logo} className={'logo-img'}/>
                    <span className={'title'}>{title}</span>
                </div>
                <div className="configs">
                    <ActionButton
                        icon={soundNotifications ? "icon-bell-regular" : "icon-bell-slash-regular"}
                        onClick={toggleNotifications}
                    />
                    {
                        (embedButton) && <ActionButton
                            icon={"icon-window-minimize"}
                            onClick={toggleFullScreen}
                        />

                    }
                    {closeButton && <ActionButton
                        icon={"icon-times-solid"}
                        onClick={toggleOpen}
                    />}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/WindowHeader.js